import { tiny_secp256k1_compat as ecc } from '@exodus/crypto/secp256k1'
import { ECPairFactory } from 'ecpair'

export const ECPair = ECPairFactory(ecc)
